import { httpClient, type ID } from '#shared'
import type { AuthInProtectedChatResponse } from '../models/auth-in-protected-chat-response'

export async function authInProtectedChat(chatId: ID, password: string) {
  const response = await httpClient.post<AuthInProtectedChatResponse>(`chats/${chatId}/private-consent`, {
    requireAuth: true,
    json: {
      password,
    },
  })

  const responseBody = await response.json()
  return responseBody
}
